<app-header></app-header>
<ng-container *ngIf="tracking$ | async"></ng-container>
<ion-content>
  <ng-container *ngIf="dyf$ | async as vm">
    <ng-container
      *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
    >
      <cdk-virtual-scroll-viewport
        id="desktop-scroll"
        class="cdk-scroll-desktop"
        orientation="vertical"
        itemSize="50"
      >
        <ion-grid [fixed]="true">
          <ion-row>
            <ion-col
              size-xl="9"
              size-lg="8"
              size-md="7"
              size-sm="12"
              size-xs="12"
            >
              <ng-container
                *ngIf="
                  vm.products?.length ||
                  (!vm.inspiredPicks?.products?.length && !vm.merchZone?.products?.length)
                "
              >
                <div class="header-wrapper">
                  <app-breadcrumbs
                    [breadcrumbs]="breadcrumbs"
                  ></app-breadcrumbs>
                  <ng-container>
                    <h1 data-cy="did-you-forget-page-title">
                      {{ 'i18n.didYouForgetPage.didYouForget' | translate }}
                    </h1>
                    <p data-cy="did-you-forget-missing-message-text">
                      ({{vm.products?.length}}) {{
                      'i18n.didYouForgetPage.productsMissingMessage' | translate
                      }}
                    </p>
                  </ng-container>
                </div>
                <div
                  class="products"
                  *ngFor="let dyfProductInfo of vm.products; trackBy: trackByProductNumber"
                >
                  <app-usf-product-card-desktop
                    [vm]="dyfProductInfo.productCardVM"
                    (ellipsisEmitter)="openProductCardEllipsis($event, dyfProductInfo, DidYouForgetCategory.DyF)"
                    (promotionClickEmitter)="clickPromotions($event)"
                    (quantityUpdateEmitter)="changeQuantityHandler($event, OrderAnalyticsMessages.didYouForget)"
                    (productCardClickEmitter)="routeToPDP($event, dyfProductInfo, DidYouForgetCategory.DyF)"
                    (infoIconClickEmitter)="openProductStatus($event)"
                  >
                  </app-usf-product-card-desktop>
                </div>
              </ng-container>

              <ng-container *ngIf="!!vm.inspiredPicks?.products?.length">
                <div class="header-wrapper">
                  <app-breadcrumbs
                    *ngIf="!vm.products?.length"
                    [breadcrumbs]="breadcrumbs"
                  ></app-breadcrumbs>
                  <ng-container>
                    <h1 data-cy="inspired-picks-label">
                      {{ vm.inspiredPicks.displayText?.headerTextDesktop }}
                    </h1>
                    <p data-cy="inspired-picks-message-text">
                      {{ vm.inspiredPicks.displayText?.subHeaderTextDesktop }}
                    </p>
                  </ng-container>
                </div>
                <div
                  class="products"
                  *ngFor="let inspiredPicksProductInfo of vm.inspiredPicks.products; trackBy: trackByProductNumber"
                >
                  <app-usf-product-card-desktop
                    [vm]="inspiredPicksProductInfo.productCardVM"
                    (ellipsisEmitter)="openProductCardEllipsis($event, inspiredPicksProductInfo, DidYouForgetCategory.InspiredPick)"
                    (promotionClickEmitter)="clickPromotions($event)"
                    (quantityUpdateEmitter)="changeQuantityHandler($event, OrderAnalyticsMessages.inspiredPicks)"
                    (productCardClickEmitter)="routeToPDP($event, inspiredPicksProductInfo, DidYouForgetCategory.InspiredPick)"
                    (infoIconClickEmitter)="openProductStatus($event)"
                  >
                  </app-usf-product-card-desktop>
                </div>
              </ng-container>

              <ng-container
                *ngIf="
                  !vm.products?.length &&
                  !vm.inspiredPicks?.products?.length &&
                  !!vm.merchZone?.products?.length
                "
              >
                <div class="header-wrapper">
                  <app-breadcrumbs
                    [breadcrumbs]="vm.merchZone?.breadcrumbs"
                  ></app-breadcrumbs>
                  <ng-container>
                    <h1
                      class="merch-zone-title"
                      data-cy="did-you-forget-merch-zone-title"
                    >
                      {{ vm.merchZone.displayText.headerText | translate }}
                    </h1>
                    <p
                      class="merch-zone-subtitle"
                      data-cy="did-you-forget-merch-zone-subtitle"
                    >
                      {{ vm?.merchZone?.displayText?.subHeaderText | translate
                      }}
                    </p>
                  </ng-container>
                </div>
                <div
                  class="products"
                  *ngFor="let merchZoneProductInfo of vm.merchZone.products; trackBy: trackByProductNumber"
                >
                  <app-usf-product-card-desktop
                    observeIntersection
                    [vm]="merchZoneProductInfo.productCardVM"
                    [id]="merchZoneProductInfo.recToken"
                    (ellipsisEmitter)="openProductCardEllipsis($event, merchZoneProductInfo, DidYouForgetCategory.MerchZone)"
                    (promotionClickEmitter)="clickPromotions($event)"
                    (quantityUpdateEmitter)="changeQuantityHandler($event, '')"
                    (productCardClickEmitter)="routeToPDP($event, merchZoneProductInfo, DidYouForgetCategory.MerchZone)"
                    (infoIconClickEmitter)="openProductStatus($event)"
                    [threshold]="0.75"
                    (impression)="trackMerchZoneImpression($event)"
                  >
                  </app-usf-product-card-desktop>
                </div>
              </ng-container>
            </ion-col>
            <ion-col
              class="desktop-sidebar"
              size-xl="3"
              size-lg="3"
              size-md="4"
              size-sm="3"
              size-xs="3"
            >
              <div>
                <!-- Order Sidebar Start-->
                <app-order-info-sidebar
                  #orderSideBar
                  [platform]="platformService?.platformType"
                  [orderHeader]="vm?.orderHeader"
                  [orderItemTallies]="vm?.orderItemTallies"
                  [isList]="false"
                  [isCart]="false"
                  [isOnMinimumOrderMetFlag]="vm?.minOrderMetEnabled"
                  [showPrintIcon]="false"
                >
                </app-order-info-sidebar>
                <!--Order Sidebar Ends-->
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>

        <div class="footer-wrapper" #desktopFooter>
          <app-footer></app-footer>
        </div>
      </cdk-virtual-scroll-viewport>
    </ng-container>

    <ng-container
      *ngIf="(this.platformService?.isTouchExperience$ | async) === true"
    >
      <cdk-virtual-scroll-viewport
        id="touch-scroll"
        class="cdk-scroll-touch"
        orientation="vertical"
        itemSize="50"
      >
        <ion-grid>
          <ion-row>
            <ion-col
              size-xl="9"
              size-lg="7"
              size-md="7"
              size-sm="7"
              size-xs="12"
            >
              <ng-container
                *ngIf="
                  vm.products?.length ||
                  (!vm.inspiredPicks?.products?.length && !vm.merchZone?.products?.length)
                "
              >
                <div class="header-wrapper">
                  <ng-container>
                    <h1 data-cy="did-you-forget-page-title">
                      {{ 'i18n.didYouForgetPage.didYouForget' | translate }}
                    </h1>
                    <p data-cy="did-you-forget-page-message-text">
                      ({{vm.products?.length}}) {{
                      'i18n.didYouForgetPage.productsMissingMessage' | translate
                      }}
                    </p>
                  </ng-container>
                </div>
                <div
                  class="products"
                  *ngFor="let dyfProductInfo of vm.products; trackBy: trackByProductNumber"
                >
                  <app-usf-product-card-touch
                    [vm]="dyfProductInfo.productCardVM"
                    (ellipsisEmitter)="openProductCardEllipsis($event, dyfProductInfo, DidYouForgetCategory.DyF)"
                    (promotionClickEmitter)="clickPromotions($event)"
                    (quantityUpdateEmitter)="changeQuantityHandler($event, OrderAnalyticsMessages.didYouForget)"
                    (productCardClickEmitter)="routeToPDP($event, dyfProductInfo, DidYouForgetCategory.DyF)"
                    (infoIconClickEmitter)="openProductStatus($event)"
                  >
                  </app-usf-product-card-touch>
                </div>
              </ng-container>
              <ng-container *ngIf="!!vm.inspiredPicks?.products?.length">
                <div class="header-wrapper">
                  <ng-container>
                    <h1 data-cy="inspired-picks-label">
                      {{ vm.inspiredPicks.displayText?.headerTextMobile }}
                    </h1>
                    <p data-cy="inspired-picks-message-text">
                      {{ vm.inspiredPicks.displayText?.subHeaderTextMobile }}
                    </p>
                  </ng-container>
                </div>
                <div
                  class="products"
                  *ngFor="let inspiredPicksProductInfo of vm.inspiredPicks.products; trackBy: trackByProductNumber"
                >
                  <app-usf-product-card-touch
                    [vm]="inspiredPicksProductInfo.productCardVM"
                    (ellipsisEmitter)="openProductCardEllipsis($event, inspiredPicksProductInfo, DidYouForgetCategory.InspiredPick)"
                    (promotionClickEmitter)="clickPromotions($event)"
                    (quantityUpdateEmitter)="changeQuantityHandler($event, OrderAnalyticsMessages.inspiredPicks)"
                    (productCardClickEmitter)="routeToPDP($event, inspiredPicksProductInfo, DidYouForgetCategory.InspiredPick)"
                    (infoIconClickEmitter)="openProductStatus($event)"
                  >
                  </app-usf-product-card-touch>
                </div>
              </ng-container>
              <ng-container
                *ngIf="
                    !vm.products?.length &&
                    !vm.inspiredPicks?.products?.length &&
                    !!vm.merchZone?.products?.length
                  "
              >
                <div class="header-wrapper">
                  <ng-container>
                    <h1
                      class="merch-zone-title"
                      data-cy="did-you-forget-merch-zone-title-touch"
                    >
                      {{ vm.merchZone.displayText.headerText | translate }}
                    </h1>
                    <p
                      class="merch-zone-subtitle"
                      data-cy="did-you-forget-merch-zone-subtitle-touch"
                    >
                      {{ vm?.merchZone?.displayText?.subHeaderText | translate
                      }}
                    </p>
                  </ng-container>
                </div>
                <div
                  class="products"
                  *ngFor="let merchZoneProductInfo of vm.merchZone.products; trackBy: trackByProductNumber"
                >
                  <app-usf-product-card-touch
                    observeIntersection
                    [id]="merchZoneProductInfo.recToken"
                    [vm]="merchZoneProductInfo.productCardVM"
                    (ellipsisEmitter)="openProductCardEllipsis($event, merchZoneProductInfo, DidYouForgetCategory.MerchZone)"
                    (promotionClickEmitter)="clickPromotions($event)"
                    (quantityUpdateEmitter)="changeQuantityHandler($event, '')"
                    (productCardClickEmitter)="routeToPDP($event, merchZoneProductInfo, DidYouForgetCategory.MerchZone)"
                    (infoIconClickEmitter)="openProductStatus($event)"
                    [threshold]="0.75"
                    (impression)="trackMerchZoneImpression($event)"
                  >
                  </app-usf-product-card-touch>
                </div>
              </ng-container>
            </ion-col>
            <ion-col
              class="touch-sidebar"
              size-xl="3"
              size-lg="4"
              size-md="4"
              push-md=".5"
              size-sm="3"
              size-xs="3"
            >
              <!--Tablet-->
              <div>
                <div class="order-info-sidebar">
                  <app-order-info-sidebar
                    [platform]="platformService?.platformType"
                    [orderHeader]="vm?.orderHeader"
                    [orderItemTallies]="vm?.orderItemTallies"
                    [isList]="false"
                    [isCart]="false"
                    [isOnMinimumOrderMetFlag]="vm?.minOrderMetEnabled"
                    [showPrintIcon]="false"
                  ></app-order-info-sidebar>
                </div>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </cdk-virtual-scroll-viewport>

      <!-- Tablet ends-->
    </ng-container>
    <!--Mobile-->
    <ion-footer
      *ngIf="(this.platformService?.isTouchExperience$ | async) === true"
    >
      <ion-toolbar id="toolbar-footer">
        <div class="toolbar-wrapper">
          <div>
            <div
              class="toolbar-total-price"
              data-cy="did-you-forget-total-price-text"
            >
              {{ 'i18n.didYouForgetPage.total' | translate }} {{
              vm.orderHeader?.totalDollars || 0 | currency }}
            </div>
            <div
              class="toolbar-products-added"
              data-cy="did-you-forget-products-added-text"
            >
              {{ 'i18n.didYouForgetPage.product' | translate }}{{
              vm.orderItemTallies?.totalItems === 1 ? '' : 's' }}:
              {{vm.orderItemTallies?.totalItems}} ({{
              vm.orderItemTallies?.totalCases || 0 }} CS / {{
              vm.orderItemTallies?.totalEaches || 0 }} EA)
            </div>
          </div>
          <ion-button
            class="usf-fill-green-button"
            (click)="routeTo('/order')"
            data-cy="back-to-current-order-button"
          >
            <ion-icon name="chevron-back-outline" class="chevron"></ion-icon>
            {{ 'i18n.didYouForgetPage.currentOrder' | translate }}
          </ion-button>
        </div>
      </ion-toolbar>
    </ion-footer>
  </ng-container>
</ion-content>
